import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyAddressAllResponse, MyReferrals, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, Providers, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse, EntryForDiscount, MasterProviders } from "../../../models/discount.model";
import { CreateTransactionResponse } from "../../../models/ev.model";

@Injectable({
  providedIn: 'root',
})

export class ApiInviteService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
  ) { }
 
 
 getReferrals(token: string, uid: string): Observable<MyReferrals> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + `/Cityparking/GetReferrals?uid=${uid}`;
    return this.http.get<MyReferrals>(url, { headers });
  }

  
    checkInviteCode(code: string): Observable<StatusAPIResponse> {
      return this.http.get<StatusAPIResponse>(
        this.tokenUrl + `/Cityparking/CheckInvite?code=${code}`,
      );
    }
}
